import { mutatorAction } from 'satcheljs';
import { getActivityFeedSettingsStore } from '../store/notificationSettingStore';

export const setActivityFeedSettings = mutatorAction(
    'SET_ACTIVITY_FEED_SETTINGS',
    (activityFeedSetting: { [key: number]: boolean }) => {
        if (activityFeedSetting) {
            Object.keys(activityFeedSetting)
                .map(Number)
                .forEach(key => {
                    getActivityFeedSettingsStore().set(key, activityFeedSetting[key]);
                });
        }
    }
);
